export const stepperList = ["amount", "recipient", "summary", "payment"] as const;
